import React from "react";

// Import Styles
import "../styles/Navbar.css";

// Import Images
import logo from "../assets/images/newlogo.png";

function Navbar() {
  return (
    <div>
      <nav className="navbar" id="navbar">
        <div className="navbar__logo">
          <img src={logo} alt="" />
        </div>
        <div className="navbar__menu">
          <a href="#" className="navbar__links">
            Inicio
          </a>

          <a href="#" className="navbar__links">
            Historia
          </a>

          <a href="#" className="navbar__links">
            Servicios
          </a>

          <a href="#" className="navbar__links">
            Contacto
          </a>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
